import { Select } from '@seiue/ui'
import React from 'react'
import styled from 'styled-components'

import { precisionOptions, valueToLabel } from './utils'

/**
 * 数字精度设置
 *
 * @param param - 参数
 * @param param.precision - 精度
 * @param param.isUserField - 是否为用户字段
 * @param param.onSelect - 选项发生变化时的回调
 * @returns React.ReactNode
 */
export const NumberSetting: React.FC<{
  isUserField?: boolean
  precision?: number
  onSelect: (v: number) => void
}> = ({ precision, isUserField, onSelect }) => {
  return (
    <NumberSettingWrapper>
      <Select
        disabled={!!isUserField}
        options={precisionOptions}
        value={precision ? valueToLabel(precisionOptions, `${precision}`) : '1'}
        onSelect={(v) => onSelect(Number(v))}
      />
    </NumberSettingWrapper>
  )
}

const NumberSettingWrapper = styled.div`
  &&& {
    .ant-select {
      width: 100%;
      height: 32px;
    }
  }
`
